import { UserRoles } from '@/enums';
import { StaffsPages } from '@/modules/staffs/shared/types';
import { all_roles } from '@/utils';

const access_roles = {
  [StaffsPages.STAFFS]: all_roles,
  [StaffsPages.STAFF_DETAIL]: all_roles,
  [StaffsPages.STAFF_EDIT]: [
    UserRoles.Internal.PARTNER_MANAGER, UserRoles.Internal.VICE_PARTNER_MANAGER,
  ],
  [StaffsPages.STAFF_CERTIFICATES]: all_roles,
};

export default access_roles;
